import { ReactNode } from "react";

import { LoadingCircle } from "@industriousoffice/react-components";

interface SummaryCardProps {
  title: string;
  message: string;
  description: string | ReactNode;
  isLoading: boolean;
}

export function SummaryCard({
  title,
  message,
  description,
  isLoading,
  ...props
}: SummaryCardProps) {
  return (
    <div
      className="rounded-lg p-3 sm:w-[400px] min-w-[285px] shadow-card"
      {...props}
    >
      {isLoading ? (
        <div className="flex items-center justify-center py-7">
          <LoadingCircle spinnerColor="#013e3f" />
        </div>
      ) : (
        <>
          <div className="text-sm">{title}</div>
          <div className="font-bold mt-2 text-xl">{message}</div>
          <div className="text-sm mt-1 text-grey-30">{description}</div>
        </>
      )}
    </div>
  );
}
